import { render, staticRenderFns } from "./Substances.vue?vue&type=template&id=24204d2e&scoped=true&"
import script from "./Substances.vue?vue&type=script&lang=js&"
export * from "./Substances.vue?vue&type=script&lang=js&"
import style0 from "./Substances.vue?vue&type=style&index=0&id=24204d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24204d2e",
  null
  
)

export default component.exports